import TrackWrapper from '~/components/common/TrackWrapper';
import CheckFilled from '~/icons/CheckFilled';
import checkListContent from './CheckListData';
import { ListItem, Section } from './EvChecklist.styles';
import { Content, Title } from '../../styles';

type ContentListProps = {
  className?: string;
  startIndex: number;
  endIndex: number;
};

const ContentList = ({
  className = '',
  startIndex,
  endIndex
}: ContentListProps) => (
  <ul className={className}>
    {checkListContent.slice(startIndex, endIndex).map(({ title, content }) => (
      <ListItem key={content} className="mb-2xl last:mb-0">
        <CheckFilled className="absolute left-[-2.25rem] mt-[2px] text-green-2" />
        <p className="text-text-strong t-heading-lg">{title}</p>
        <p className="mt-md text-text-default t-body-md">{content}</p>
      </ListItem>
    ))}
  </ul>
);

export default function EvChecklist() {
  const midpointIndex = Math.ceil(checkListContent.length / 2);

  return (
    <TrackWrapper event={{ eventName: 'Viewed - Ev Checklist' }}>
      <Section>
        <Title>Recap: your used EV checklist</Title>
        <div className="grid gap-7xl md:grid-cols-2">
          <ContentList
            className="md:hidden"
            startIndex={0}
            endIndex={checkListContent.length}
          />
          <ContentList
            className="hidden md:block"
            startIndex={0}
            endIndex={midpointIndex}
          />
          <ContentList
            className="hidden md:block"
            startIndex={midpointIndex}
            endIndex={checkListContent.length}
          />
        </div>
        <Content>
          Armed with the knowledge and insights we’ve provided, you’ll be ready
          to confidently navigate the used EV market and make an informed
          decision for your next purchase. Happy driving!
        </Content>
      </Section>
    </TrackWrapper>
  );
}
